export default __webpack_public_path__ + "static/media/paid.9698818c.png";